import {di} from "@dp-instant/core";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {BackButton} from "@game/ui/components/BackButton/BackButton";
import {ProgressBar} from "@game/ui/components/ProgressBar/ProgressBar";
import cn from "classnames";
import {DebugPanelGamePlay} from "../debug/DebugPanelGamePlay";
import {ParticipantItem} from "../interface/ParticipantItem";
import "./GamePlayScreen.less";

type GamePlayScreenProps = {
    participants?: ParticipantItem[];
};
export const GamePlayScreen = (props: GamePlayScreenProps) => {
    return (
        <div className={cn("screen", "screen__game-play")}>
            <div className={cn("container", "back-btn")}>
                <BackButton onClick={() => di.get<GameModel>(TypesGame.model).exitTheGame()} />
            </div>
            <div className="container">
                <ProgressBar participants={props.participants} />
            </div>
            {process.env.NODE_ENV === "development" ? <DebugPanelGamePlay /> : null}
        </div>
    );
};
